module.exports = __webpack_public_path__ + "media/logos/dynamic-logo-b343b19a.png";